import { render, staticRenderFns } from "./AddEditTag.vue?vue&type=template&id=8cce3786&scoped=true"
import script from "./AddEditTag.vue?vue&type=script&lang=js"
export * from "./AddEditTag.vue?vue&type=script&lang=js"
import style0 from "./AddEditTag.vue?vue&type=style&index=0&id=8cce3786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cce3786",
  null
  
)

export default component.exports